import React, { useState, useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";

import { getPrepaymentSnapshot } from "../emailCampaign.store";
import AuthPin from "../../lenderReportingDashboard/lenderView/AuthPin";
import { CardButtonFilled } from "../../../components/Admin/AppsSettings/CardStyles";

import { PrepaymentPreview } from "./";

const DEFAULT_PIN_LENGTH = 6;

const ImageBanner = styled.div`
    background-image: url(/images/campaign-banner.png);
    background-size: cover;
    background-position: center;
    width: 100%;
    min-height: 320px;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: center;
    height: 100vh;
    width: 100vw;
    font-family: Work Sans;
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    height: 220px;
`;

const StyledButton = styled(CardButtonFilled)`&& {
    background: ${({ pin }) => pin.length === DEFAULT_PIN_LENGTH ? "#005AA9" : "#C4C4C4"};
    width: 262px;
    height: 48px;
    border: none;
    font-family: Work Sans;
    font-size: 16px;
    font-weight: 500;
    line-height: 19px;
}`;

const Instructions = styled.div`
    font-size: 22px;
    font-weight: 400;
    line-height: 24px;
`;

const LeftWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 1em;
    width: 70%;
    min-width: 620px;
`;

const RightWrapper = styled.div`
    width: 30%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-top: 3em;
    min-width: 266px;
`;

const PinError = styled.span`
    font-family: Work Sans;
    font-size: 18px;
    font-weight: 400;
    line-height: 20px;
    color: #C40A0A;
`;

const SnapshotContainer = styled.div`
    width: 904px;
    height: 100%;
`;

const PrepaymentSnapshot = ({ getPrepaymentSnapshot, match, emailCampaign }) => {
  const [askForPin, setAskForPin] = useState(true);
  const [pin, setPin] = useState("");
  const [data, setData] = useState({});
  const [showPinError, setShowPinError] = useState(false);
  const [userHasSubmitted, setUserHasSubmitted] = useState(false);

  useEffect(() => {
    const { dealId } = match.params;
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const ssId = params.get("ssId");
    getPrepaymentSnapshot({
      dealId,
      ssId
    });
  }, []);

  const handleCallForData = () => {
    setUserHasSubmitted(true);
    const { dealId } = match.params;
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const ssId = params.get("ssId");
    getPrepaymentSnapshot({
      dealId,
      ssId,
      pin
    });
  };

  useEffect(() => {
    if (emailCampaign.prepaymentSnapshot && emailCampaign.prepaymentSnapshot.error) {
      if (userHasSubmitted) {
        setShowPinError(true);
      }
    } else if (emailCampaign.prepaymentSnapshot[0] && !emailCampaign.prepaymentSnapshot.error) {
      setData(emailCampaign.prepaymentSnapshot);
      setAskForPin(false);
    } else {
      setData({});
    }
  }, [emailCampaign]);

  const handleOnChange = pinInput => setPin(pinInput);

  return (
    <Container>
      <ImageBanner />
      {askForPin &&
        <Wrapper>
          <LeftWrapper>
            <Instructions>Please enter the PIN found in your email to access this secure content.</Instructions>
            <AuthPin onChange={handleOnChange} heightWidth={88} fontSize={16} />
            <StyledButton disabled={`${pin}`.length !== DEFAULT_PIN_LENGTH} onClick={handleCallForData} pin={pin}>
              Unlock Prepayment Report
            </StyledButton>
          </LeftWrapper>
          <RightWrapper>
            {userHasSubmitted && showPinError && <PinError>Incorrect PIN</PinError>}
          </RightWrapper>
        </Wrapper>}
      {!askForPin &&
        <SnapshotContainer>
          <PrepaymentPreview data={data} />
        </SnapshotContainer>}
    </Container>
  );
};

const mapStateToProps = ({ emailCampaign }) => ({ emailCampaign });

export default compose(connect(mapStateToProps, {
  getPrepaymentSnapshot
}))(PrepaymentSnapshot);
